<workflow [RBACORG]="RBACORG" [PERMISSION]="PERMISSION" [n8nEvent]="n8nEvent"></workflow>
